export default {
  "content": "<path fill=\"#707070\" d=\"M2.862 5.294a8.837 8.837 0 003.844 3.844l1.283-1.283a.58.58 0 01.595-.14c.654.216 1.36.332 2.083.332.32 0 .583.263.583.584v2.036c0 .32-.262.583-.583.583A9.916 9.916 0 01.75 1.333c0-.32.262-.583.583-.583h2.042c.32 0 .583.262.583.583 0 .73.117 1.43.333 2.083a.585.585 0 01-.146.595L2.862 5.294z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "12",
    "height": "12",
    "fill": "none",
    "viewBox": "0 0 12 12"
  }
};